import './component.scss'
import { Controller } from "stimulus";

window.Stimulus.register(
  'nurikae-company-review-sort-menu',
  class extends Controller {

    // NOTE: ソートメニューのURLをaタグで実装するとクローラーに辿られてしまう
    // 本来は辿られたくないので、JS遷移にすることでこの問題に対応する (検証段階)
    navigate(event) {
      const url = event.currentTarget.dataset.nurikaeCompanyReviewSortMenuUrlValue;
      if (url) {
        window.location.href = url;
      }
    }
  }
)
